var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "qr-code-modal" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            { staticClass: "qr-code-container", attrs: { id: "qrcodeBox" } },
            [
              _vm.qrCodeData.shortUrl
                ? _c("vue-qr", {
                    attrs: {
                      text: _vm.qrCodeData.shortUrl,
                      size: 300,
                      margin: 0,
                    },
                  })
                : _c("div", { staticClass: "qr-code-placeholder" }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "button-container" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "download-btn",
                  on: { click: _vm.downloadQrCodeFunc },
                },
                [_vm._v("下载二维码")]
              ),
              _c(
                "button",
                { staticClass: "close-btn", on: { click: _vm.handleClose } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }